export default __webpack_public_path__ + "3ab1afa6a6f1cb1d5d182b4beccac093.png";